module.exports = __webpack_public_path__ + "static/media/export-excel-icon.c7b68c15.svg";